<template>
  <div class="svgItem">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      height="100%"
      width="100%"
      preserveAspectRatio="none"
      viewBox="929.61 0 4175.78 1595"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="2964.831"
          y1="-756"
          x2="3095.169"
          y2="1731"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.396"
            :stop-color="primary ? primary : color.primary"
          />
          <stop
            offset="0.401"
            :stop-color="primary ? primary : color.primary"
          />
          <stop offset="1.06" :stop-color="primary ? primary : color.primary" />
        </linearGradient>
        <filter
          id="filter"
          x="-366"
          y="-805"
          width="6693"
          height="2586"
          filterUnits="userSpaceOnUse"
        >
          <feOffset result="offset" dx="-50" in="SourceAlpha" />
          <feGaussianBlur result="blur" stdDeviation="7.071" />
          <feFlood result="flood" flood-opacity="0.15" />
          <feComposite result="composite" operator="in" in2="blur" />
          <feBlend result="blend" in="SourceGraphic" />
        </filter>
      </defs>
      <path
        id="green"
        class="cls-1"
        d="M-266.985,1731s136.552-415.65,639.975-450.72c745.95-51.97,664.74,94.49,1186.07,77.44,513.93-16.81,493.84-177.91,1069.21-195.28,567.06-17.12,657.36,177.45,1146.88,161.14,482.83-16.09,526.36,154.75,1057.22,97.39,636.64-68.79,642.91,165.19,1219.36-23.6,610.4-199.91,15.11-2153.377,15.11-2153.377H-33.5Z"
      />
    </svg>
    <!-- <div class="overlay"></div> -->
  </div>
</template>

<script>
export default {
  props: ["primary"],
  data() {
    return {
      color: this.$vuetify.theme.themes.light,
    };
  },
};
</script>
<style lang="scss">
svg {
  position: relative;
}
.svgItem {
  width: 100%;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.3) 100%);
  height: 60%;
  width: 100%;
  z-index: 11;
}

.cls-1 {
  fill-rule: evenodd;
  fill: url(#linear-gradient);
  filter: url(#filter);
}
</style>
